export default "__VITE_ASSET__X1IE3pOs__"